import classNames from 'classnames';
import ContentBlock from '../ContentBlock';
import Txt from '../Txt';
import styles from './StatItem.module.scss';

/**
 * StatItem
 *
 * @return {JSX.Element}
 */
const StatItem = ({ className, label, value }) => {
  return (
    <ContentBlock
      className={classNames(styles.StatItem, className, StatItem.displayName)}
      column
      gapHalf
      alignCenter
    >
      <Txt noWrap regular>
        {label}
      </Txt>
      <Txt bold>{value}</Txt>
    </ContentBlock>
  );
};

StatItem.displayName = 'StatItem';

export default StatItem;
